import translations from './translations'

translations.add('en', {
    mainDescription: 'Your payment is being processed',
    tokenizationDescription: 'Card registration in progress',
    verificationDescription: 'Card verification in progress',
    secondaryDescription: 'Please wait, do not close or refresh the page'
})
